import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus, faMinus} from '@fortawesome/free-solid-svg-icons';

import './common.scss';

const CENTS_IN_DOLLAR = 100;

/**
 * The CreditCounter Component
 */
class CreditCounter extends Component {
  /**
   * Renders the CreditCounter Component
   * @returns {{}}
   */
  render() {
    const {quantity, pricePerCredit, updateCredit, paymentSchedule, title, unit} = this.props;
    const onCreditIncrement = () => updateCredit(quantity + 1);
    const onCreditDecrement = () => updateCredit(quantity - 1);

    return (
      <div>
        <div className="item-title text-center">
          {title}
        </div>
        <div className="text-center text-uppercase pb-3">
          ${(pricePerCredit / CENTS_IN_DOLLAR)} per {unit}
        </div>
        <div className="credit-buttons">
          <button
            data-cy="download-credit-decrement-button"
            type="button"
            className="btn btn-sm btn-dark"
            onClick={onCreditDecrement}
          >
            <FontAwesomeIcon icon={faMinus} />
          </button>
          <input
            className="credit-field"
            maxLength="1"
            value={quantity}
            onChange={(e) => updateCredit(Number(e.target.value))}
          />
          <button
            data-cy="download-credit-increment-button"
            type="button"
            className="btn btn-sm btn-dark"
            onClick={onCreditIncrement}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </div>

        <div className="item-price">
          <div className="item-price-text">Total</div>
          <sup className="item-currency">$</sup>
          <span className="item-price-number">
            {(pricePerCredit / CENTS_IN_DOLLAR) * quantity} {paymentSchedule
              && (<span className="item-currency">/ {paymentSchedule}</span>)}
          </span>
        </div>
      </div>
    );
  }
}

CreditCounter.propTypes = {
  pricePerCredit: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  updateCredit: PropTypes.func.isRequired,

  paymentSchedule: PropTypes.string,
  title: PropTypes.string,
  unit: PropTypes.string,
};

CreditCounter.defaultProps = {
  title: 'Credit Total',
  unit: 'credit',
};

export default observer(CreditCounter);
